// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Route Editor Modal Styles
 */

.route-editor-modal__overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 1rem;
}

.route-editor-modal {
  background: var(--cfn-modal-bg, #fff);
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.route-editor-modal__header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--cfn-border-muted, #e5e7eb);
  background: var(--cfn-modal-header-bg, #f9fafb);
  flex-wrap: wrap;
}

.route-editor-modal__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--cfn-text-primary, #111827);
}

.route-editor-modal__title-icon {
  color: var(--cfn-primary, #3b82f6);
}

.route-editor-modal__header-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.route-editor-modal__label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--cfn-text-secondary, #6b7280);
}

.route-editor-modal__toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--cfn-text-secondary, #6b7280);
  cursor: pointer;
}

.route-editor-modal__toggle input {
  width: 1rem;
  height: 1rem;
}

.route-editor-modal__close {
  margin-left: auto;
  padding: 0.25rem;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--cfn-text-muted, #9ca3af);
  cursor: pointer;
  transition: color 0.15s ease;
}

.route-editor-modal__close:hover {
  color: var(--cfn-text-primary, #111827);
}

/* Body */
.route-editor-modal__body {
  flex: 1;
  overflow-y: auto;
  padding: 1.25rem;
}

.route-editor-modal__table-wrapper {
  max-height: 35vh;
  overflow-y: auto;
  margin-bottom: 1rem;
  border: 1px solid var(--cfn-border-muted, #e5e7eb);
  border-radius: 8px;
}

.route-editor-modal__empty {
  padding: 2rem;
  text-align: center;
  color: var(--cfn-text-muted, #9ca3af);
}

.route-editor-modal__empty p {
  margin: 0;
}

.route-editor-modal__empty-hint {
  font-size: 0.875rem;
  margin-top: 0.5rem !important;
}

.route-editor-modal__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.route-editor-modal__table th,
.route-editor-modal__table td {
  padding: 0.5rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--cfn-border-muted, #e5e7eb);
}

.route-editor-modal__table th {
  background: var(--cfn-table-header-bg, #f9fafb);
  font-weight: 600;
  color: var(--cfn-text-primary, #111827);
  position: sticky;
  top: 0;
}

.route-editor-modal__table tbody tr:hover {
  background: var(--cfn-table-row-hover, #f3f4f6);
}

.route-editor-modal__table tfoot td {
  background: var(--cfn-table-header-bg, #f9fafb);
  font-weight: 600;
}

.route-editor-modal__table-select {
  width: 100%;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid var(--cfn-input-border, #d1d5db);
  border-radius: 4px;
  background: var(--cfn-input-bg, #fff);
  color: var(--cfn-input-text, #111827);
}

.route-editor-modal__no-noi {
  color: var(--cfn-text-muted, #9ca3af);
}

.route-editor-modal__length {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.route-editor-modal__divider {
  border: none;
  border-top: 1px solid var(--cfn-border-muted, #e5e7eb);
  margin: 1rem 0;
}

/* Form */
.route-editor-modal__form {
  display: grid;
  gap: 1rem;
}

.route-editor-modal__field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.route-editor-modal__field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--cfn-text-secondary, #6b7280);
}

.route-editor-modal__input,
.route-editor-modal__select {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid var(--cfn-input-border, #d1d5db);
  border-radius: 6px;
  background: var(--cfn-input-bg, #fff);
  color: var(--cfn-input-text, #111827);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.route-editor-modal__input:focus,
.route-editor-modal__select:focus {
  outline: none;
  border-color: var(--cfn-input-focus-border, #3b82f6);
  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring, rgba(59, 130, 246, 0.25));
}

.route-editor-modal__select--small {
  padding: 0.25rem 0.5rem;
  font-size: 0.8125rem;
}

.route-editor-modal__error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--cfn-danger-bg, #fef2f2);
  color: var(--cfn-danger-text, #dc2626);
  border-radius: 6px;
  font-size: 0.875rem;
  margin-top: 1rem;
}

/* Footer */
.route-editor-modal__footer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--cfn-border-muted, #e5e7eb);
  background: var(--cfn-modal-footer-bg, #f9fafb);
  flex-wrap: wrap;
}

.route-editor-modal__footer-spacer {
  flex: 1;
}

.route-editor-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}

.route-editor-modal__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.route-editor-modal__btn--primary {
  background: var(--cfn-btn-primary-bg, #3b82f6);
  color: var(--cfn-btn-primary-text, #fff);
}

.route-editor-modal__btn--primary:hover:not(:disabled) {
  background: var(--cfn-btn-primary-hover-bg, #2563eb);
}

.route-editor-modal__btn--secondary {
  background: var(--cfn-btn-secondary-bg, #f3f4f6);
  color: var(--cfn-btn-secondary-text, #374151);
  border: 1px solid var(--cfn-btn-secondary-border, #d1d5db);
}

.route-editor-modal__btn--secondary:hover:not(:disabled) {
  background: var(--cfn-btn-secondary-hover-bg, #e5e7eb);
}

.route-editor-modal__btn--danger {
  background: var(--cfn-btn-danger-bg, #dc2626);
  color: var(--cfn-btn-danger-text, #fff);
}

.route-editor-modal__btn--danger:hover:not(:disabled) {
  background: #b91c1c;
}

.route-editor-modal__btn--warning {
  background: #f59e0b;
  color: #fff;
}

.route-editor-modal__btn--warning:hover:not(:disabled) {
  background: #d97706;
}

.route-editor-modal__spinner {
  animation: route-editor-spin 1s linear infinite;
}

@keyframes route-editor-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 640px) {
  .route-editor-modal__header {
    gap: 0.75rem;
  }

  .route-editor-modal__header-controls {
    width: 100%;
    order: 1;
  }

  .route-editor-modal__close {
    order: 0;
  }

  .route-editor-modal__footer {
    flex-direction: column;
  }

  .route-editor-modal__footer-spacer {
    display: none;
  }

  .route-editor-modal__btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/home/components/modals/route-editor-modal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB;wCACsC;EACtC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yDAAyD;EACzD,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,sDAAsD;EACtD,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,0DAA0D;AAC5D;;AAEA;;EAEE,aAAa;EACb,oDAAoD;EACpD,2EAA2E;AAC7E;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yCAAyC;EACzC,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sDAAsD;EACtD,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;EAC7C,0DAA0D;AAC5D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\n * Route Editor Modal Styles\n */\n\n.route-editor-modal__overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 1rem;\n}\n\n.route-editor-modal {\n  background: var(--cfn-modal-bg, #fff);\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header */\n.route-editor-modal__header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--cfn-border-muted, #e5e7eb);\n  background: var(--cfn-modal-header-bg, #f9fafb);\n  flex-wrap: wrap;\n}\n\n.route-editor-modal__title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--cfn-text-primary, #111827);\n}\n\n.route-editor-modal__title-icon {\n  color: var(--cfn-primary, #3b82f6);\n}\n\n.route-editor-modal__header-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.route-editor-modal__label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--cfn-text-secondary, #6b7280);\n}\n\n.route-editor-modal__toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--cfn-text-secondary, #6b7280);\n  cursor: pointer;\n}\n\n.route-editor-modal__toggle input {\n  width: 1rem;\n  height: 1rem;\n}\n\n.route-editor-modal__close {\n  margin-left: auto;\n  padding: 0.25rem;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: var(--cfn-text-muted, #9ca3af);\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.route-editor-modal__close:hover {\n  color: var(--cfn-text-primary, #111827);\n}\n\n/* Body */\n.route-editor-modal__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem;\n}\n\n.route-editor-modal__table-wrapper {\n  max-height: 35vh;\n  overflow-y: auto;\n  margin-bottom: 1rem;\n  border: 1px solid var(--cfn-border-muted, #e5e7eb);\n  border-radius: 8px;\n}\n\n.route-editor-modal__empty {\n  padding: 2rem;\n  text-align: center;\n  color: var(--cfn-text-muted, #9ca3af);\n}\n\n.route-editor-modal__empty p {\n  margin: 0;\n}\n\n.route-editor-modal__empty-hint {\n  font-size: 0.875rem;\n  margin-top: 0.5rem !important;\n}\n\n.route-editor-modal__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.route-editor-modal__table th,\n.route-editor-modal__table td {\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--cfn-border-muted, #e5e7eb);\n}\n\n.route-editor-modal__table th {\n  background: var(--cfn-table-header-bg, #f9fafb);\n  font-weight: 600;\n  color: var(--cfn-text-primary, #111827);\n  position: sticky;\n  top: 0;\n}\n\n.route-editor-modal__table tbody tr:hover {\n  background: var(--cfn-table-row-hover, #f3f4f6);\n}\n\n.route-editor-modal__table tfoot td {\n  background: var(--cfn-table-header-bg, #f9fafb);\n  font-weight: 600;\n}\n\n.route-editor-modal__table-select {\n  width: 100%;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--cfn-input-border, #d1d5db);\n  border-radius: 4px;\n  background: var(--cfn-input-bg, #fff);\n  color: var(--cfn-input-text, #111827);\n}\n\n.route-editor-modal__no-noi {\n  color: var(--cfn-text-muted, #9ca3af);\n}\n\n.route-editor-modal__length {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.route-editor-modal__divider {\n  border: none;\n  border-top: 1px solid var(--cfn-border-muted, #e5e7eb);\n  margin: 1rem 0;\n}\n\n/* Form */\n.route-editor-modal__form {\n  display: grid;\n  gap: 1rem;\n}\n\n.route-editor-modal__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.route-editor-modal__field label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--cfn-text-secondary, #6b7280);\n}\n\n.route-editor-modal__input,\n.route-editor-modal__select {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--cfn-input-border, #d1d5db);\n  border-radius: 6px;\n  background: var(--cfn-input-bg, #fff);\n  color: var(--cfn-input-text, #111827);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.route-editor-modal__input:focus,\n.route-editor-modal__select:focus {\n  outline: none;\n  border-color: var(--cfn-input-focus-border, #3b82f6);\n  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring, rgba(59, 130, 246, 0.25));\n}\n\n.route-editor-modal__select--small {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8125rem;\n}\n\n.route-editor-modal__error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--cfn-danger-bg, #fef2f2);\n  color: var(--cfn-danger-text, #dc2626);\n  border-radius: 6px;\n  font-size: 0.875rem;\n  margin-top: 1rem;\n}\n\n/* Footer */\n.route-editor-modal__footer {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 1.25rem;\n  border-top: 1px solid var(--cfn-border-muted, #e5e7eb);\n  background: var(--cfn-modal-footer-bg, #f9fafb);\n  flex-wrap: wrap;\n}\n\n.route-editor-modal__footer-spacer {\n  flex: 1;\n}\n\n.route-editor-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease, opacity 0.15s ease;\n}\n\n.route-editor-modal__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.route-editor-modal__btn--primary {\n  background: var(--cfn-btn-primary-bg, #3b82f6);\n  color: var(--cfn-btn-primary-text, #fff);\n}\n\n.route-editor-modal__btn--primary:hover:not(:disabled) {\n  background: var(--cfn-btn-primary-hover-bg, #2563eb);\n}\n\n.route-editor-modal__btn--secondary {\n  background: var(--cfn-btn-secondary-bg, #f3f4f6);\n  color: var(--cfn-btn-secondary-text, #374151);\n  border: 1px solid var(--cfn-btn-secondary-border, #d1d5db);\n}\n\n.route-editor-modal__btn--secondary:hover:not(:disabled) {\n  background: var(--cfn-btn-secondary-hover-bg, #e5e7eb);\n}\n\n.route-editor-modal__btn--danger {\n  background: var(--cfn-btn-danger-bg, #dc2626);\n  color: var(--cfn-btn-danger-text, #fff);\n}\n\n.route-editor-modal__btn--danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.route-editor-modal__btn--warning {\n  background: #f59e0b;\n  color: #fff;\n}\n\n.route-editor-modal__btn--warning:hover:not(:disabled) {\n  background: #d97706;\n}\n\n.route-editor-modal__spinner {\n  animation: route-editor-spin 1s linear infinite;\n}\n\n@keyframes route-editor-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .route-editor-modal__header {\n    gap: 0.75rem;\n  }\n\n  .route-editor-modal__header-controls {\n    width: 100%;\n    order: 1;\n  }\n\n  .route-editor-modal__close {\n    order: 0;\n  }\n\n  .route-editor-modal__footer {\n    flex-direction: column;\n  }\n\n  .route-editor-modal__footer-spacer {\n    display: none;\n  }\n\n  .route-editor-modal__btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
